<script setup>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { flowThreadContextKey } from './flowThreadContext';
import NodeInlineField from '../ui/NodeInlineField.vue';

defineProps({
  node: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const context = inject(flowThreadContextKey);
</script>

<template>
  <div class="bg-white px-3 py-3">
    <div class="flex items-center gap-2.5">
      <div
        class="flex h-10 w-10 items-center justify-center rounded-full bg-n-slate-2 text-n-slate-11"
      >
        <i class="i-lucide-contact-round text-lg" />
      </div>
      <div class="min-w-0 flex-1">
        <NodeInlineField
          v-if="isSelected"
          :model-value="node.config?.formattedName || ''"
          :placeholder="t('MOBILE_CONVERSATION_FLOWS.EDITOR.CONTACT_FALLBACK')"
          variant="plain"
          @update:model-value="context.updateNode({ formattedName: $event })"
        />
        <div v-else class="truncate text-[12px] font-semibold text-n-slate-12">
          {{
            node.config?.formattedName ||
            t('MOBILE_CONVERSATION_FLOWS.EDITOR.CONTACT_FALLBACK')
          }}
        </div>
        <NodeInlineField
          v-if="isSelected"
          :model-value="node.config?.phoneNumber || ''"
          :placeholder="context.uiCopy.phonePlaceholder"
          variant="plainSoft"
          @update:model-value="context.updateNode({ phoneNumber: $event })"
        />
        <div
          v-else
          class="mt-0.5 text-[11px]"
          :class="
            node.config?.phoneNumber ? 'text-n-slate-11' : 'text-n-slate-9'
          "
        >
          {{ node.config?.phoneNumber || context.uiCopy.phonePlaceholder }}
        </div>
      </div>
    </div>

    <div class="mt-2 flex justify-between border-t border-black/5 pt-2">
      <button
        type="button"
        class="flex-1 text-center text-[12px] font-medium text-[#128c7e]"
      >
        {{ context.uiCopy.messageAction }}
      </button>
      <div class="mx-3 w-px bg-black/5" />
      <button
        type="button"
        class="flex-1 text-center text-[12px] font-medium text-[#128c7e]"
      >
        {{ context.uiCopy.saveContactAction }}
      </button>
    </div>
  </div>
</template>
